var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.691,
    height: 44.692,
    viewBox: "0 0 44.691 44.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_1217174_instagram_icon",
    "data-name": "1217174_instagram_icon",
    transform: "translate(-8.856 -8.892)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M53.541,31.238c0,3.224.009,6.449,0,9.682a11.981,11.981,0,0,1-6.088,10.6,13.878,13.878,0,0,1-7.494,2.054c-5.872,0-11.736.027-17.608-.009a13.655,13.655,0,0,1-10.376-4.494,11.556,11.556,0,0,1-3.044-6.629A13.8,13.8,0,0,1,8.86,40.83q0-9.633,0-19.265a12.011,12.011,0,0,1,6.1-10.61A13.952,13.952,0,0,1,22.5,8.9c5.854,0,11.709-.027,17.563.009a13.647,13.647,0,0,1,10.4,4.521,11.518,11.518,0,0,1,3.008,6.593,27.18,27.18,0,0,1,.072,2.963C53.55,25.744,53.541,28.491,53.541,31.238Zm-41.34,0c0,3.305-.009,6.6,0,9.907a8.265,8.265,0,0,0,2.387,5.845,10.312,10.312,0,0,0,7.656,3.242c5.917.036,11.826.009,17.743.009a10.611,10.611,0,0,0,5.386-1.369,8.787,8.787,0,0,0,4.846-8.043v-19.5a8.172,8.172,0,0,0-2.36-5.809,10.25,10.25,0,0,0-7.638-3.269c-5.98-.045-11.952-.018-17.932-.018a10.5,10.5,0,0,0-5.251,1.36A8.8,8.8,0,0,0,12.2,21.646Z",
    transform: "translate(0 0)",
    fill: "#4d4d4d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M151.475,153.715A10.358,10.358,0,1,1,161.985,143.4,10.415,10.415,0,0,1,151.475,153.715Zm0-3.332a7.026,7.026,0,1,0-7.142-7.043A7.1,7.1,0,0,0,151.475,150.383Z",
    transform: "translate(-120.243 -112.93)",
    fill: "#4d4d4d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M363,100.306a2.208,2.208,0,1,1,2.225,2.288A2.25,2.25,0,0,1,363,100.306Z",
    transform: "translate(-322.248 -81.082)",
    fill: "#4d4d4d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.453aa97226e5ab27cce76df1549997cd.svg";
export { ForwardRef as ReactComponent };